import { useEffect } from 'react'
import { getSessionId, load, page } from './analytics'
import { useLocation, useMatches } from '@remix-run/react'
import * as sessionReplay from '@amplitude/session-replay-browser'
import * as Sentry from '@sentry/remix'

export type AnalyticsInitProps = {
  analyticsWriteKey: string
  analyticsDataPlaneUrl: string
}

type RouteMatchWithHandle = {
  handle?: {
    pageName?: string
  }
  pathname: string
}

export function useInitializeAnalytics({
  analyticsWriteKey,
  analyticsDataPlaneUrl,
}: AnalyticsInitProps) {
  const sessionId = getSessionId()
  useEffect(() => {
    load(analyticsWriteKey, analyticsDataPlaneUrl).catch((error: unknown) => {
      Sentry.captureException(error)
    })
  }, [analyticsWriteKey, analyticsDataPlaneUrl])

  useEffect(() => {
    if (sessionId) {
      sessionReplay.setSessionId(sessionId)
    }
  }, [sessionId])
}

export function useTrackPageView() {
  const location = useLocation()
  const matches = useMatches() as RouteMatchWithHandle[]

  useEffect(() => {
    const match = matches.find((m) => m.pathname === location.pathname)

    const pageName = match?.handle?.pageName || `${location.pathname}`
    page(pageName)
  }, [location.pathname])
}
